/**
 * @module app.um
 */

import { autoinject, bindable } from 'aurelia-framework';
import { ComponentBase, SortDirection, Sorting } from 'app/shared/lib/essette-site';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { apiCall } from 'app/shared/lib/essette-api';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { AuthService } from 'app/um/services/auth-service';
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class AuthTypeSubClassHistory extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable
    protected authId: string | null = null;
    protected authTypeClassHistory: Array<UM.AuthTypeClassHistory> = [];

    private sorting = new Sorting();
    protected resultCount = 0;
    protected pageSize = 10;

    ////****************** Element References ***************************************////
    protected $pager!: EssPagerCustomElement;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: AuthService,
        ...rest: any[]) {
        super(...rest);

        // Default Sort
        this.sorting.entries = [
            {
                reference: 'audit.start.timestamp',
                direction: SortDirection.Descending
            }
        ];
    }

    protected bind(): void {
        this.reload();
    }

    ////****************** Events ***************************************************////
    /** Handles the grid's sort event */
    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }

        this.reload();
    }

    ////****************** Functions ************************************************////
    public async reload(): Promise<void> {
        await this.loadAuthTypeClassHistory();
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuthTypeClassHistory(): Promise<void> {
        if(!this.authId) { return; }

        const includes = [
            'audit.start',
            'audit.start.user',
            'class.subClass',
            'type'
        ];

        const options: Partial<IQueryLoadOptions> = {
            sorting: this.sorting,
            top: this.pageSize,
            page: this.$pager?.page || 0
        };

        try {
            this.state.beginLoad();

            const response = await this.service.loadAuthTypeClassHistoryByAuth(this.authId, options, includes);
            this.authTypeClassHistory = response.results;
            this.resultCount = response.count || 0;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }

    }
}
